import { Typography, Box } from '@mui/material';
import { SectorSentimentWidget } from '../components/widgets/SectorSentimentWidget';

export default function Sectors() {
  return (
    <>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Sector Sentiment Analysis
        </Typography>
        <Typography variant="body1" color="text.secondary">
          AI-powered sector sentiment with configurable sector selection
        </Typography>
      </Box>

      {/* Sector Sentiment Widget */}
      <Box sx={{ mb: 3 }}>
        <SectorSentimentWidget />
      </Box>
    </>
  );
}
